module.exports = __webpack_public_path__ + "img/puzzle3.8dd40bdb.png";